export const aboutData = {
    title: "Who I am",
    description1: "I’m Saikumar, a full-stack developer with 3 years of experience in Java Spring Boot,PostgreSQL and React.js.",
    description2: "I’m currently working as a Full Stack Developer at APCFSS, where I build and maintain enterprise-level web applications. I’m passionate about learning new technologies and continuously improving my skills in software development and system design.",
    image: 2
}
